import { useEffect, useState } from "react";
import type { CategoryChild } from "../../../services/categories/types";

export interface UseArticleTabStateResult {
  activeId: string;
  visited: Set<string>;
  handleTabChange: (newValue: string) => void;
}

export const useArticleTabState = (
  subcategories: CategoryChild[]
): UseArticleTabStateResult => {
  const first = subcategories[0];
  const firstSlug = first?.slug ?? "";
  const firstId = first ? String(first.id) : "";

  const [activeId, setActiveId] = useState<string>(firstSlug);
  const [visited, setVisited] = useState<Set<string>>(() =>
    firstId ? new Set([firstId]) : new Set()
  );

  useEffect(() => {
    if (!firstSlug || !firstId) return;
    const validSlugs = new Set(subcategories.map((child) => child.slug));
    if (activeId && validSlugs.has(activeId)) return;
    setActiveId(firstSlug);
    setVisited(new Set([firstId]));
  }, [activeId, firstSlug, firstId, subcategories]);

  const handleTabChange = (newValue: string) => {
    setActiveId(newValue);
    const child = subcategories.find((c) => c.slug === newValue);
    if (!child) return;
    const childId = String(child.id);
    setVisited((current) => {
      if (current.has(childId)) return current;
      const next = new Set(current);
      next.add(childId);
      return next;
    });
  };

  return { activeId, visited, handleTabChange };
};
